import { styled } from 'styled-components';

// unused
export const TeamPlusMinusPage = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.small};

  > div:last-of-type {
    max-height: 21.2rem;
  }
`;

// unused
export const TeamPlusMinusHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: ${({ theme }) => theme.sizing.small};
`;

export const TeamPlusMinusControls = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.sizing.small};
`;

TeamPlusMinusPage.displayName = 'TeamPlusMinusPage';
TeamPlusMinusHeader.displayName = 'TeamPlusMinusHeader';
TeamPlusMinusControls.displayName = 'TeamPlusMinusControls';
